export const editorialPhotos = {
  'hero-laboratory': {
    'directory': "editorial",
    'file': "09-hero-laboratory",
    'alt': "Sunlit laboratory with a microscope, analyzer and neatly arranged capped sample tubes.",
    'caption': "Illustrative diagnostic laboratory"
  },
  'hero-technical': {
    'directory': "editorial",
    'file': "10-hero-technical",
    'alt': "Two healthcare engineering professionals discussing equipment beside an ultrasound cart.",
    'caption': "Illustrative technical collaboration"
  },
  'home-laboratory': {
    'directory': "editorial",
    'file': "11-home-laboratory",
    'alt': "Gloved hands preparing a specimen rack beside a compact laboratory analyzer.",
    'caption': "Illustrative laboratory preparation"
  },
  'home-technical': {
    'directory': "editorial",
    'file': "12-home-technical",
    'alt': "Female biomedical engineer checking an inactive infusion pump in a bright workshop.",
    'caption': "Illustrative equipment support"
  },
  'overview-medical': {
    'directory': "editorial",
    'file': "13-overview-medical",
    'alt': "Clinical equipment bay with a hospital bed, mobile imaging cart and monitoring equipment.",
    'caption': "Illustrative clinical equipment"
  },
  'overview-laboratory': {
    'directory': "editorial",
    'file': "14-overview-laboratory",
    'alt': "Microscope and diagnostic equipment on a laboratory bench with neatly arranged supplies.",
    'caption': "Illustrative diagnostic workbench"
  },
  'overview-consumables': {
    'directory': "editorial",
    'file': "15-overview-consumables",
    'alt': "Organized clinical supply trolley holding sealed disposable supplies and protective equipment.",
    'caption': "Illustrative supply organisation"
  },
  'detail-medical': {
    'directory': "editorial",
    'file': "16-detail-medical",
    'alt': "Bright operating theatre with an operating table, surgical lights and equipment.",
    'caption': "Illustrative operating theatre"
  },
  'detail-consumables': {
    'directory': "editorial",
    'file': "17-detail-consumables",
    'alt': "Sealed clinical supplies arranged on a white preparation counter.",
    'caption': "Illustrative sterile supplies"
  },
  'service-maintenance-card': {
    'directory': "editorial",
    'file': "18-service-maintenance-card",
    'alt': "Close view of equipment testing tools beside an inactive patient monitor.",
    'caption': "Illustrative equipment testing"
  },
  'service-engineering-card': {
    'directory': "editorial",
    'file': "19-service-engineering-card",
    'alt': "Female healthcare engineer and a colleague reviewing equipment in a hospital corridor.",
    'caption': "Illustrative biomedical teamwork"
  },
  'detail-installation': {
    'directory': "editorial",
    'file': "20-detail-installation",
    'alt': "Technical team positioning a newly delivered imaging cart in a clinical room.",
    'caption': "Illustrative equipment installation"
  },
  'detail-maintenance': {
    'directory': "editorial",
    'file': "21-detail-maintenance",
    'alt': "Organized calibration workbench with testing equipment and medical accessories.",
    'caption': "Illustrative maintenance workbench"
  },
  'detail-engineering': {
    'directory': "editorial",
    'file': "22-detail-engineering",
    'alt': "Two technical professionals inspecting a laboratory centrifuge in a workshop.",
    'caption': "Illustrative technical inspection"
  },
  'detail-procurement': {
    'directory': "editorial",
    'file': "23-detail-procurement",
    'alt': "Overhead view of professionals reviewing a facility layout and equipment requirements.",
    'caption': "Illustrative procurement planning"
  },
  'about-training': {
    'directory': "editorial",
    'file': "24-about-training",
    'alt': "Small group of healthcare professionals attending a practical equipment orientation session.",
    'caption': "Illustrative staff orientation"
  }
} as const;

